import React, { useState, useEffect, useContext } from 'react'
import { useDebounce } from '@usap/core'
import { Box, Text, AccordionPanel } from '@usap/uicomponents'
import { TextWithPointer, TextInputWithIcon } from '@usap/widgets'
import seoIds from '../../../../config/seoIds'
import { GTM } from '../../../helpers'
import RefineSubList from './RefineSubList'
import { SearchContext } from '../../common/context/SearchContextProvider'
import PageTypeIdentifier from '../../../helpers/PageTypeIdentifier'

// checks whether checkbox is checked or unchecked
const getHasChecked = (refine, refName) => refine && refine.includes(refName)

export default function RefineBody(props) {
  const {
    refineItem,
    placeholder,
    checkList = [],
    maxShow = 10,
    updateRefine,
    data,
    parent,
    showSearch,
  } = props

  const {
    searchState: { isSearch },
  } = useContext(SearchContext)

  const [searchValue, searchChange] = useState('')
  const [label, toggleList] = useState(true)
  const [results, setResults] = useState(checkList)
  const [activeStatus, setActiveStatus] = useState(false)

  // The goal is to only have the search call fire when user stops typing
  // so that we aren't hitting our search call rapidly.
  const debounceSearchValue = useDebounce(searchValue, 300)

  const checkListLength = checkList.length

  const handleCheckBoxChange = (checked, parmaParent, name, link) => {
    if (!checked) {
      const { filteredSelection } = GTM
      const pageTitle = isSearch ? 'SERP' : 'Product Category Page'

      filteredSelection({
        filterCategory: parmaParent,
        filterSelected: name,
        pageTitle,
      })
    }

    PageTypeIdentifier.setIdentifier(window?.pageType || null)
    updateRefine(link)
  }

  useEffect(() => {
    let checkListFiltred = checkList
    if (debounceSearchValue) {
      checkListFiltred = checkListFiltred.filter(({ text }) => text.toLowerCase().includes(searchValue.toLowerCase()))
    }
    setResults(checkListFiltred)
  }, [debounceSearchValue, checkList, searchValue])

  return (
    <AccordionPanel
      onClick={e => {
        e.stopPropagation()
        if (!label) {
          toggleList(true)
        }
        if (e.target.id) {
          setActiveStatus(!activeStatus)
        }
      }}
      id={refineItem}
      label={(
        <Text
          size="small"
          weight="bold"
          color="dark-2"
          margin={{ vertical: 'medium' }}
        >
          {parent}
        </Text>
      )}
    >
      <Box
        id={seoIds.refineItemsGrid.replace('{{key}}', refineItem)}
        style={{
          display: activeStatus || showSearch ? 'block' : 'none',
        }}
      >
        {checkListLength > maxShow && (
          <Box
            id={`refinementTextInput-${refineItem}`}
            pad={{ bottom: 'xxsmall' }}
            style={{
              minHeight: 'fit-content',
            }}
          >
            <TextInputWithIcon
              placeholder={placeholder || 'Search'}
              onChangeCB={value => searchChange(value)}
              ariaLabel={placeholder || 'Search'}
            />
          </Box>
        )}
        <RefineSubList
          refinementSubList={results}
          refineItem={refineItem}
          maxShow={maxShow}
          data={data}
          getHasChecked={getHasChecked}
          handleCheckBoxChange={handleCheckBoxChange}
          parent={parent}
          label={label}
        />
        {!searchValue && checkListLength && maxShow < checkListLength && (
          <Box
            id={label ? `seeAll${parent}` : `seeLess${parent}`}
            onClick={e => e.stopPropagation()}
          >
            <TextWithPointer
              onClick={() => toggleList(!label)}
              size="small"
              color="blueLink"
              margin="medium"
            >
              {label ? 'See All' : 'See Less'}
            </TextWithPointer>
          </Box>
        )}
      </Box>
    </AccordionPanel>
  )
}
